function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import View from './view';
import Viewport from '../viewports/viewport';
import { Matrix4, _SphericalCoordinates as SphericalCoordinates } from 'math.gl';
import FirstPersonController from '../controllers/first-person-controller';

function getDirectionFromBearingAndPitch(_ref) {
  var bearing = _ref.bearing,
      pitch = _ref.pitch;
  var spherical = new SphericalCoordinates({
    bearing: bearing,
    pitch: pitch
  });
  var direction = spherical.toVector3().normalize();
  return direction;
}

var FirstPersonView =
/*#__PURE__*/
function (_View) {
  _inherits(FirstPersonView, _View);

  function FirstPersonView() {
    _classCallCheck(this, FirstPersonView);

    return _possibleConstructorReturn(this, _getPrototypeOf(FirstPersonView).apply(this, arguments));
  }

  _createClass(FirstPersonView, [{
    key: "_getViewport",
    value: function _getViewport(props) {
      // TODO - push direction handling into Matrix4.lookAt
      var _props$viewState = props.viewState,
          _props$viewState$mode = _props$viewState.modelMatrix,
          modelMatrix = _props$viewState$mode === void 0 ? null : _props$viewState$mode,
          bearing = _props$viewState.bearing,
          _props$viewState$up = _props$viewState.up,
          up = _props$viewState$up === void 0 ? [0, 0, 1] : _props$viewState$up; // Always calculate direction from bearing and pitch

      var dir = getDirectionFromBearingAndPitch({
        bearing: bearing,
        pitch: 89
      }); // Direction is relative to model coordinates, of course

      var center = modelMatrix ? modelMatrix.transformDirection(dir) : dir; // Just the direction. All the positioning is done in viewport.js

      var viewMatrix = new Matrix4().lookAt({
        eye: [0, 0, 0],
        center: center,
        up: up
      });
      return new Viewport(Object.assign({}, props, {
        zoom: null,
        // triggers meter level zoom
        viewMatrix: viewMatrix
      }));
    }
  }, {
    key: "controller",
    get: function get() {
      return this._getControllerProps({
        type: FirstPersonController
      });
    }
  }]);

  return FirstPersonView;
}(View);

export { FirstPersonView as default };
FirstPersonView.displayName = 'FirstPersonView';
//# sourceMappingURL=first-person-view.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@deck.gl/core/dist/esm/views/first-person-view.js
// module id = 925
// module chunks = 0